<template>
<div>
  <h1>Local Floor</h1>
  <div v-if="loading">Loading...</div>
  <div v-else-if="error">Error: {{ error }}</div>
  <ul v-else>
    <li v-for="article in articles" :key="article.id" ref="articlelist">
      <h2><a :href="`/articleinfo?cid=${ article.CID }`" v-html="article.Title"></a></h2>
      <p>Abstract: <i v-html="article.Abstract"></i></p>
      <p>
        Author:
        <a :href="`/profile?username=${ article.AuthorName }`">
          {{ article.AuthorName }}
        </a>
      </p>
      <p>Published on: {{ article.CreatedAt }}</p>
      <p>CID: <a :href="`https://ipfs.io/ipfs/${article.CID}`">{{ article.CID }}</a></p>
      Download:
      <a :href="`${ config.apiBaseUrl }/articles/pdf/${article.CID}`" style="margin-right:10px;" download>
        Local PDF
      </a>
      <a :href="`${ config.apiBaseUrl }/articles/bibtex/${article.CID}`" style="margin-right:10px;" download>
        BibTeX
      </a>
      <a :href="`https://ipfs.io/ipfs/${article.SigStampCID}`" style="margin-right:10px;" download>
        OpenTimeStamp
      </a>
      <a :href="`https://ipfs.io/ipfs/${article.SigCID}`" style="margin-right:10px;" download>
        GPG Signature
      </a>
      <button v-if="isAdmin" @click="deleteArticle(article.CID)" style="color: Red;">Delete</button>
    </li>
  </ul>
</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import config from '../config';

export default {
  name: 'ArticleList',
  mounted() {
    const isAdmin = sessionStorage.getItem('is_admin');
    this.isAdmin = isAdmin === '1'; // Set true if `is_admin` is 1
  },
  setup() {
    const articles = ref([]);
    const loading = ref(true);
    const error = ref(null);

    const token = sessionStorage.getItem("jwt");

    const fetchArticles = async () => {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/articles`); // Replace with your actual API endpoint
        if (!response.ok) {
          throw new Error('Failed to fetch articles');
        }
        const data = await response.json();
        articles.value = data;
      } catch (err) {
        error.value = err.message;
      } finally {
        loading.value = false;
      }
    };

    const deleteArticle = async (cid) => {
      if (window.confirm("Are you sure you want to delete this article?")) {
        try {
          const response = await fetch(`${ config.apiBaseUrl }/admin/article/delete/${cid}`, {
            method: 'DELETE',
            headers: {
              "Authorization": `Bearer ${token}`,
            }
          });
          if (!response.ok) {
            throw new Error('Failed to perform the action');
          }
          alert('Article deleted successfully!');
          fetchArticles();
        } catch (err) {
          alert(`Error: ${err.message}`);
        }
      } else {
        console.log("Cancelled.");
      }
    };

    onMounted(fetchArticles);

    return {
      articles,
      deleteArticle,
      loading,
      config,
      error
    };
  }
};
</script>

<style scoped>
/* Optional styling */
h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 1em;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1em;
}
</style>
